import { render, staticRenderFns } from "./LoadsTable.vue?vue&type=template&id=162049c3&scoped=true&"
import script from "./LoadsTable.vue?vue&type=script&lang=js&"
export * from "./LoadsTable.vue?vue&type=script&lang=js&"
import style0 from "./LoadsTable.vue?vue&type=style&index=0&id=162049c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162049c3",
  null
  
)

export default component.exports